import { render, staticRenderFns } from "./EstoqueConsultarConsumosPacientes.vue?vue&type=template&id=4e55d6d2&"
import script from "./EstoqueConsultarConsumosPacientes.vue?vue&type=script&lang=js&"
export * from "./EstoqueConsultarConsumosPacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports